import React, { useEffect, useState } from "react";
import { Error, Success } from "../../Messages/Messages";
import axios from "axios";
import DeleteModal from "../../DeleteModal/DeleteModal";
import BreadCrump from "../../BreadCrump/BreadCrump";
import AddAssets from "./AddAssets";
import UpdateAssets from "./UpdateAssets";
import { isAuthenticated } from "../../Auth/auth";
import DropdownComp from "../../Dropdowns/DropdownComp";
import GeneralTable from "../../../commons/GeneralTable";
import dayjs from "dayjs";
import PageToolbar from "../../../design-system/PageToolbar";

import { useTranslation } from "react-i18next";
const EmployeeAssets = ({ employeeObject, serviceProvider }) => {
  const { t } = useTranslation("dashboard");
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [totalCount, setTotalCount] = useState("");
  const [pageNo, setPageNo] = useState(1);
  const [pageSize] = useState(15);

  const getData = async () => {
    setLoading(true);
    await axios
      .post(
        `${process.env.REACT_APP_BACKEND_URL}/assets/get`,
        {
          employee: employeeObject?._id,
          serviceProvider: serviceProvider && isAuthenticated()?.serviceProviderId
        },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token")
          }
        }
      )
      .then(res => {
        setLoading(false);
        if (res.status === 200 || res.status === 304) {
          setData(res.data?.data);
          setTotalCount(res.data?.count);
        } else {
          Error(res.data.errorMessage);
        }
      })
      .catch(err => {
        setLoading(false);
        Error(err.message);
      });
  };

  const deleteHandler = async id => {
    await axios
      .delete(`${process.env.REACT_APP_BACKEND_URL}/assets/delete/${id}`, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token")
        }
      })
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          Success(res.data.successMessage);
          getData();
        } else {
          Error(res.data.errorMessage);
        }
      })
      .catch(err => {
        Error(err.message);
      });
  };

  useEffect(() => {
    getData();
  }, []);

  const columns = [
    {
      title: "#",
      dataIndex: "_id",
      mobile: "hidden",
      render: (text, record, index) => index + 1
    },
    {
      title: t("Asset Type"),
      dataIndex: "type",
      mobile: "subtitle",
      sorter: (a, b) => a.type.localeCompare(b.type)
    },
    {
      title: t("Title"),
      dataIndex: "title",
      mobile: "title",
      sorter: (a, b) => a.title.localeCompare(b.title)
    },
    {
      title: t("Taken By"),
      dataIndex: "employee",
      sorter: (a, b) => a.employee?.firstName?.localeCompare(b?.employee?.firstName),
      render: employee => (employee ? employee?.firstName + " " + employee?.lastName : null)
    },
    {
      title: t("Taken Date"),
      dataIndex: "startDate",
      render: text => dayjs(text).format("DD/MMM/YYYY") || "N/A",
      sorter: (a, b) =>
        dayjs(a.startDate).format("DD/MMM/YYYY") - dayjs(b.startDate).format("DD/MMM/YYYY")
    },
    {
      title: t("Return Date"),
      dataIndex: "endDate",
      render: text => dayjs(text).format("DD/MMM/YYYY") || "N/A",
      sorter: (a, b) =>
        dayjs(a.startDate).format("DD/MMM/YYYY") - dayjs(b.startDate).format("DD/MMM/YYYY")
    },
    {
      title: t("Note"),
      dataIndex: "note"
    },
    {
      title: t("Status"),
      dataIndex: "status",
      sorter: (a, b) => a.status.localeCompare(b.status),
      render: status => <div>{status ? t(status) : null}</div>
    },
    {
      title: t("Action"),
      key: "action",
      align: "right",
      render: (text, obj) => {
        const menuItems = [
          {
            key: "edit",
            component: () => <UpdateAssets employeeObject={obj} updateParent={getData} />
          },
          {
            key: "delete",
            component: () => <DeleteModal text="Asset" onClick={() => deleteHandler(obj?._id)} />
          }
        ];
        return (
          <div>
            <DropdownComp menuItems={menuItems} />
          </div>
        );
      }
    }
  ];

  return (
    <>
      <PageToolbar
        actions={
          <AddAssets
            serviceProvider={serviceProvider}
            updateParent={getData}
            employeeObject={employeeObject}
          />
        }
      />

      <GeneralTable
        pageNo={pageNo}
        pageSize={pageSize}
        totalCount={totalCount}
        data={data}
        columns={columns}
        setPageNo={setPageNo}
        loading={loading}
      />
    </>
  );
};

export default EmployeeAssets;
